import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import LoadingIndicator from '../LoadingIndicator';
import ScrollableContent from '../ScrollableContent';
import UserList from './UserList';
import s from './Who.scss';
var Who = /** @class */ (function (_super) {
    tslib_1.__extends(Who, _super);
    function Who() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            isScrolled: false,
            isScrolledToBottom: false,
        };
        _this.loadMore = function () {
            var _a = _this.props, loadMore = _a.loadMore, streamId = _a.streamId, isFetching = _a.isFetching, hasMore = _a.hasMore;
            hasMore && !isFetching && loadMore(streamId);
        };
        _this.onLoadMoreClick = function () {
            _this.setState({ isOpen: true });
            _this.loadMore();
        };
        _this.onListScroll = function (scrollTop, distanceToBottom) {
            var _a = _this.state, isScrolled = _a.isScrolled, isScrolledToBottom = _a.isScrolledToBottom, isOpen = _a.isOpen;
            var isScrolledNew = scrollTop !== 0;
            var isScrolledBottomNew = distanceToBottom < 1;
            if (isScrolled === isScrolledNew &&
                isScrolledToBottom === isScrolledBottomNew) {
                // let's only update state when something actually changed because things can get laggy
                return;
            }
            _this.setState({
                isScrolled: isScrolledNew,
                isScrolledToBottom: isScrolledBottomNew,
            });
            if (isOpen && distanceToBottom < 30) {
                _this.loadMore();
            }
        };
        return _this;
    }
    Who.prototype.componentDidMount = function () {
        var _a = this.props, isInitialized = _a.isInitialized, initialize = _a.initialize, streamId = _a.streamId, userListType = _a.userListType, deviationId = _a.deviation.deviationId;
        // on first display, load more
        if (!isInitialized) {
            initialize(streamId, deviationId, userListType);
        }
    };
    Who.prototype.componentDidUpdate = function (_a) {
        var prevUsers = _a.users;
        var _b = this.props, users = _b.users, scheduleTooltipUpdate = _b.scheduleTooltipUpdate;
        // if the number of our users changed, need to update our host tooltip...
        if (scheduleTooltipUpdate && users.length !== prevUsers.length) {
            scheduleTooltipUpdate();
        }
    };
    Who.prototype.render = function () {
        var _a = this.props, headline = _a.headline, users = _a.users, hasMore = _a.hasMore, total = _a.total, isFetching = _a.isFetching, errorMsg = _a.errorMsg, _b = _a.t, t = _b === void 0 ? function (key) { return key; } : _b;
        var _c = this.state, isScrolled = _c.isScrolled, isScrolledToBottom = _c.isScrolledToBottom, isOpen = _c.isOpen;
        var hasOverflow = hasMore || total > 5;
        var showLoadMore = !isOpen && hasOverflow && !errorMsg;
        var isEmpty = !users.length && !isFetching && !hasMore;
        return (React.createElement("div", { className: classnames(s['root'], !isOpen && s['closed'], isScrolled && s['scrolled'], isScrolledToBottom && !hasMore && s['bottomed']) },
            React.createElement("div", { className: s['title'] }, headline),
            errorMsg && React.createElement("div", { className: s['error'] }, errorMsg),
            isEmpty && React.createElement("div", { className: s['empty'] }, t('who.empty')),
            users.length > 0 && (React.createElement(ScrollableContent, { className: s['user-list-wrap'], throttleTimeout: 300, onScrolled: this.onListScroll },
                React.createElement(UserList, { users: users }),
                hasOverflow && React.createElement("div", { className: s['fade'] }))),
            isFetching && (React.createElement(LoadingIndicator, { view: "llama", className: s['loading'] })),
            showLoadMore && this.renderLoadMoreButton()));
    };
    Who.prototype.renderLoadMoreButton = function () {
        var itemsShownWhenClosed = 5;
        var _a = this.props, isFetching = _a.isFetching, total = _a.total, t = _a.t;
        var remaining = Math.max(total - itemsShownWhenClosed, 0); // we show 5 items when closed
        return (React.createElement("button", { disabled: isFetching, className: s['more'], onClick: this.onLoadMoreClick }, t('who.more', { count: remaining })));
    };
    return Who;
}(React.Component));
export { Who };
export default withTranslation()(Who);
//# sourceMappingURL=Who.js.map